import React, { useEffect, useState } from 'react';
import Genero from './Genero';
import DataNascimento from './DataNascimento';
import Altura from './Altura';
import NivelAtividade from './NivelAtividade';
import Objetivo from './Objetivo';
import PesoAtual from './PesoAtual';
import PesoDesejado from './PesoDesejado';

import './quiz.css';

const API_BASE = process.env.REACT_APP_API_BASE;

const Quiz = () => {
  const [etapa, setEtapa] = useState('');
  const [loading, setLoading] = useState(true);

  const carregarProximaEtapa = async () => {
    try {
      const res = await fetch(`${API_BASE}/check-progresso.php`, {
        credentials: 'include'
      });

      const data = await res.json();

      if (data.proxima_etapa) {
        setEtapa(data.proxima_etapa);
      } else {
        // ✅ Agora redireciona para a tela de resultado final
        window.location.href = '/resultado';
      }
    } catch (error) {
      console.error('Erro ao carregar progresso do quiz:', error);
      window.location.href = '/';
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarProximaEtapa();
  }, []);

  const renderizarEtapa = () => {
    switch (etapa) {
      case 'genero':
        return <Genero onSucesso={carregarProximaEtapa} />;
      case 'data_nascimento':
        return <DataNascimento onSucesso={carregarProximaEtapa} />;
      case 'altura_cm':
        return <Altura onSucesso={carregarProximaEtapa} />;
      case 'nivel_atividade':
        return <NivelAtividade onSucesso={carregarProximaEtapa} />;
      case 'objetivo':
        return <Objetivo onSucesso={carregarProximaEtapa} />;
      case 'peso_atual':
        return <PesoAtual onSucesso={carregarProximaEtapa} />;
      case 'peso_desejado':
        return <PesoDesejado onSucesso={carregarProximaEtapa} />;
      default:
        return <p>Continuando de onde você parou... {etapa}</p>;
    }
  };

  return (
    <div className="quiz-background">
      {loading ? (
        <div className="quiz-carregando">
          <div className="quiz-spinner"></div>
          <p>Carregando seu progresso...</p>
        </div>
      ) : (
        renderizarEtapa()
      )}
    </div>
  );
};

export default Quiz;
